export const GraphBoxPlot = ({
  fillColor,
  width = '10rem',
}: {
  fillColor: string;
  width?: string;
}) => (
  <svg width={width} viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'>
    {/* Axes */}
    <line x1='0' y1='0' x2='0' y2='20' stroke={fillColor} strokeWidth={1} />
    <line x1='0' y1='20' x2='20' y2='20' stroke={fillColor} strokeWidth={1} />
    {/* Chart */}
    <polyline
      points='2,7 4,7 3,7 3,11 2,11 2,15 3,15 3,16 2,16 4,16 3,16 3,15 4,15 4,11 3,11'
      fill='none'
      stroke={fillColor}
      strokeWidth={0.5}
    />
    <polyline
      points='7,4 9,4 8,4 8,6 7,6 7,9 8,9 8,13 7,13 9,13 8,13 8,9 9,9 9,6 8,6'
      fill='none'
      stroke={fillColor}
      strokeWidth={0.5}
    />
    <polyline
      points='17,2 19,2 18,2 18,4 17,4 17,9 18,9 18,11 17,11 19,11 18,11 18,9 19,9 19,4 18,4'
      fill='none'
      stroke={fillColor}
      strokeWidth={0.5}
    />
    <polyline
      points='12,5 14,5 13,5 13,10 12,10 12,12 13,12 13,15 12,15 14,15 13,15 13,12 14,12 14,10 13,10'
      fill='none'
      stroke={fillColor}
      strokeWidth={0.5}
    />
  </svg>
);
